import React, { useContext, useState } from "react";
import { Link } from "react-router-dom";
import "./ClassicTheme2.css";
import { saveAs } from "file-saver";
import {
  BsCursor,
  BsPlus,
  BsQrCodeScan,
  BsUpload,
  BsWhatsapp,
} from "react-icons/bs";
import { FiLink, FiMail } from "react-icons/fi";
import { BiMobileAlt } from "react-icons/bi";
import { RiMessage2Line } from "react-icons/ri";
import { IoIosArrowForward } from "react-icons/io";

import background from "../../../assests/img1/background.jpg";
import { useTranslation } from "react-i18next";
import { SocialMediaValid } from "../Common/DivValidation";
import ListSocialMediaCls from "../Common/socialMedia/ListSocialMediaCls";
import ListSocialMediaClassic from "../Common/socialMedia/ListSocialMediaClassic";
import ExchangeContact from "../Common/exchangeContactModal/ExchangeContact";
import WebsiteCls from "../Common/websiteCards/WebsiteCls";
import Footer from "../Common/footer/Footer";
import QRModal from "../Common/qrModals/QRModal";
import ProfileCardNew from "../Common/profileCards/ProfileCardNew";
import { useQueryClient } from "@tanstack/react-query";
import { updateTapCount } from "../../helpers/tapCountMutation";
import ReviewCardCls from "../Common/reviewCards/ReviewCardCls";
import DownloadsCardCls from "../Common/fileDownloadsCards/DownloadsCardCls";
import { CardContext } from "../../store/CardContext";

const defaultBackgroundImage =
  "https://zeeqr-files.s3.ap-south-1.amazonaws.com/assets/defaultBackground.jpg";
const defaultProfileImage =
  "https://zeeqr-files.s3.ap-south-1.amazonaws.com/assets/defaultProfile.jpg";

function ClassicTheme2({ card, preview }) {
  const [cardData] = useContext(CardContext);
  const {
    backgroundImage,
    website,
    review,
    fileName,
    files,
    checkPfCard,
    footerText,
  } = cardData;

  const headlines = card?.headlines;
  // console.log(card?.phoneNumbers, "card?.phoneNumbers");

  const [qrModal, setQrModal] = useState(false);

  const handleShare = () => {
    if (navigator.share) {
      navigator
        .share({
          text: "Please check it out.",
          url: window.location.href,
          title: card.name,
        })
        .then(() => console.log("Successful share"))
        .catch((error) => console.log("Error sharing", error));
    }
  };

  const [showResults, setShowResults] = useState(false);
  const onClick = () => setShowResults(true);
  const handleClose = (e) => {
    setQrModal(false);
    setShowResults(false);
  };

  const handleDownload = () => {
    let url = card?.QRCode;
    saveAs(url, card?.name);
  };

  const Highlightcolor = card?.colorCode ? card?.colorCode : "";
  const Textcolor = card?.textColor ? card?.textColor : "";
  const Iconcolor = card?.iconBgColor ? card?.iconBgColor : "#000000";
  const BgColor = card?.bgColor ? card?.bgColor : "";
  const BtIColor = card?.btIconColor ? card?.btIconColor : "#ffffff";

  const shareMail = (e) => {
    window.location = `mailto:${card?.email ? card?.email : card?.emailList[0]?.email}`;
    e.preventDefault();
  };

  const shareMail2 = (e) => {
    window.location = `mailto:${card?.secondaryEmail}`;
    e.preventDefault();
  };

  const shareMailAccording = (e, mail) => {
    window.location = `mailto:${mail}`;
    e.preventDefault();
  };

  const array = card?.name ? card?.name?.split(" ") : "";

  const SocialMediaImageCheck = SocialMediaValid();

  const { t } = useTranslation();

  const imageStyle = {
    backgroundSize: card?.bgImgType ? card?.bgImgType : "cover",
    backgroundPosition: "center ",
    backgroundImage: `url(${card?.bgImg})`,
    backgroundRepeat: card?.bgImgRepeat ? card?.bgImgRepeat : "no-repeat",
  };
  const colorStyle = {
    backgroundSize: "100%",
    backgroundPosition: "center ",
    backgroundColor: BgColor,
  };
  const defaultStyle = {
    backgroundSize: "100%",
    backgroundPosition: "center ",
    backgroundImage: `url(${background})`,
  };

  const getWhatsappNumber = card?.socialMedias?.filter(
    (item) => item?.platform === "Whatsapp"
  );
  const whatsappNumber =
    card?.socialMedias && card?.socialMedias?.length !== 0
      ? getWhatsappNumber[0]?.link
        ? getWhatsappNumber[0]?.link
        : ""
      : card?.whatsappNumber;
  const whatsappMessage =
    card?.socialMedias && card?.socialMedias?.length !== 0
      ? getWhatsappNumber[0]?.message
        ? getWhatsappNumber[0]?.message
        : ""
      : "";
  const encodedMessage = encodeURIComponent(whatsappMessage);

  const exchangeButton = (
    <span
      className="addToContactCls2 flex"
      style={{ backgroundColor: `${Iconcolor ? Iconcolor : "black"}` }}
    >
      <p
        className="w-12 ml-6 my-3 text-white text-xs"
        style={{ color: `${BtIColor ? BtIColor : "white"}` }}
      >
        {card?.exchangeContact?.buttonName}
      </p>
      <div
        className="ml-6 rounded-full   my-2 p-2 w-10 h-10"
        src=""
        alt=""
        style={{
          backgroundColor: `${Highlightcolor ? Highlightcolor : "white"}`,
        }}
      >
        <BsUpload size={22} color={Iconcolor ? Iconcolor : "black"} />
      </div>
    </span>
  );

  /* ------------------ tap count taking using tanstack query ----------------- */

  const queryClient = useQueryClient();

  const handleTap = (button) => {
    // console.log("iiii");

    updateTapCount(queryClient, button);
  };

  //------------------------------------------------------------------------------------------------------
  return (
    <div>
      {/* <Helmet>
        <title class="notranslate" >{card?.name}</title>
        <link rel="icon" href={profileImage[0]?.thumbUrl} />
        <link rel="apple-touch-icon" sizes="144x144" href={profileImage[0]?.thumbUrl} ></link>
        <meta name="description" class="notranslate" content={card?.companyDesignation} />
        <meta property="og:title" class="notranslate" content={card?.name} />
        <meta property="og:type" content="website" />
        <meta property="og:description" class="notranslate" content={card?.companyDesignation} />
        <meta property="og:image" content={profileImage[0]?.thumbUrl} />
      </Helmet> */}

      <section
        className="previewWrap2"
        style={card?.bgImg ? imageStyle : BgColor ? colorStyle : defaultStyle}
      >
        {/* -------------------------------------------------------------flotting buttons------------------------------------------------------------------ */}

        {preview ? (
          <>
            <span
              style={{
                backgroundColor: `${Iconcolor ? Iconcolor : ""}`,
              }}
              className="qr-code1"
              onClick={() => setQrModal(true)}
            >
              <BsQrCodeScan size={22} color={BtIColor} />
            </span>
            <Link
              style={{
                backgroundColor: `${Iconcolor ? Iconcolor : ""}`,
              }}
              className="share"
              onClick={handleShare}
            >
              {/* <img src={shareIcon} alt="" /> */}
              <BsUpload size={23} color={BtIColor} />
            </Link>
            {/* <Link style={{
                  backgroundColor: `${Iconcolor ? Iconcolor : ""
                    }`}} className="addToContact" to={`${vCard}`}>
              <img src={addIcon} alt="" />
            </Link> */}
            <div className="fixed bottom-[27px] right-[27px] z-50 flex flex-col gap-3">
              <Link
                onClick={() => handleTap("saveContact")}
                className="addToContactCls2 flex"
                to={`${card?.vCard}`}
                style={{
                  backgroundColor: `${Iconcolor ? Iconcolor : "black"}`,
                }}
              >
                <p
                  className="w-12 ml-6 my-3 text-white text-xs"
                  style={{ color: `${BtIColor ? BtIColor : "white"}` }}
                >
                  {t("addToContact", "Add to Contacts")}
                </p>
                <div
                  className="ml-6 rounded-full   my-2 p-2 w-10 h-10"
                  src=""
                  alt=""
                  style={{
                    backgroundColor: `${
                      Highlightcolor ? Highlightcolor : "white"
                    }`,
                  }}
                >
                  <BsPlus size={23} color={Iconcolor ? Iconcolor : "black"} />
                </div>
              </Link>
              {card?.exchangeContact?.show ? (
                <ExchangeContact
                  customButton={exchangeButton}
                  details={card?.exchangeContact}
                  cardId={card._id}
                />
              ) : (
                ""
              )}
            </div>
          </>
        ) : (
          ""
        )}

        {/* ---------------------------------------------------- background image --------------------------------------------------------------------------- */}

        <div className="bannerImage2">
          {card?.backgroundImage ? (
            <img src={card?.backgroundImage} alt="" />
          ) : (
            <img src={defaultBackgroundImage} alt="" />
          )}
          {/* <img src={card.backgroundImage ? card.backgroundImage : 'https://zeeqr-files.s3.ap-south-1.amazonaws.com/assets/defaultBackground.jpg' } alt='' /> */}
        </div>
        <div className="previewContainer2">
          <div className="header"></div>

          {/* ---------------------------------------------------- profile card --------------------------------------------------------------------------- */}

          {card?.checkPfCard ? (
            card?.otherFields?.credentials || card?.otherFields?.divison ? (
              <ProfileCardNew
                Highlightcolor={Highlightcolor}
                Textcolor={Textcolor}
              />
            ) : (
              <div
                className={`userDetails ${
                  !card?.checkProfile ? "flex flex-col jutify-center" : ""
                }`}
                style={{
                  backgroundColor: `${
                    card?.pfCardColor
                      ? card?.pfCardColor
                      : Highlightcolor
                      ? Highlightcolor
                      : ""
                  }`,
                }}
              >
                {card?.checkProfile ? (
                  <figure>
                    {card?.profileImage ? (
                      <img src={card?.profileImage} alt="" />
                    ) : (
                      <img src={defaultProfileImage} alt="" />
                    )}
                  </figure>
                ) : (
                  ""
                )}
                <div
                  className="user"
                  style={{
                    width: `${card?.checkProfile ? "calc(100% - 122px)" : ""}`,
                  }}
                >
                  <h1
                    style={{
                      color: `${
                        card?.pfCardColor ? "black" : Textcolor ? Textcolor : ""
                      }`,
                      width: `${!card?.checkProfile ? "max-content" : ""}`,
                      textShadow: `${card?.nameShadowHide && "none"}`,
                      fontSize: `${
                        array[0]?.length > 12 ||
                        array[1]?.length > 12 ||
                        array[2]?.length > 12
                          ? "20px"
                          : card?.nameSize
                          ? `${card?.nameSize}px`
                          : ""
                      }`,
                    }}
                  >
                    {" "}
                    {card?.name}
                  </h1>
                  <p
                    style={{
                      color: `${
                        card?.pfCardColor ? "black" : Textcolor ? Textcolor : ""
                      }`,
                      fontSize: `${
                        card?.designationSize
                          ? card?.designationSize + "px"
                          : ""
                      }`,
                    }}
                  >
                    {card?.companyDesignation}
                  </p>
                </div>
              </div>
            )
          ) : (
            ""
          )}
          {/* --------------------------------------------------- profile card 1 ---------------------------------------------------------------------------- */}

          {card?.otherFields?.checkPfCard1 ? (
            <div
              className={`userDetails ${
                !card?.otherFields?.checkProfile1
                  ? "flex flex-col jutify-center"
                  : ""
              }`}
              style={{
                backgroundColor: `${
                  card?.pfCardColor
                    ? card?.pfCardColor
                    : Highlightcolor
                    ? Highlightcolor
                    : ""
                }`,
              }}
            >
              <div
                className="user "
                style={{
                  width: `${
                    card?.otherFields?.checkProfile1 ? "calc(100% - 122px)" : ""
                  }`,
                }}
              >
                {/* <h1 style={{ width: `${!card?.otherFields?.checkProfile1 ? "max-content" : ''}`, fontSize: `${array1[0]?.length > 12 || array1[1]?.length > 12 || array1[2]?.length > 12 ? '20px' : ''}` }} >{card?.otherFields?.pfCard1name1}</h1>
                <h1 style={{ width: `${!card?.otherFields?.checkProfile1 ? "max-content" : ''}`, fontSize: `${array2[0]?.length > 12 || array2[1]?.length > 12 || array2[2]?.length > 12 ? '20px' : ''}` }} >{card?.otherFields?.pfCard1name2}</h1> */}
                <h1
                  style={{
                    width: `${
                      !card?.otherFields?.checkProfile1 ? "max-content" : ""
                    }`,
                    fontSize: `${
                      card?.otherFields?.pfCard1name1size
                        ? card?.otherFields?.pfCard1name1size + "px"
                        : ""
                    }`,
                  }}
                >
                  {card?.otherFields?.pfCard1name1}
                </h1>
                <h1
                  style={{
                    width: `${
                      !card?.otherFields?.checkProfile1 ? "max-content" : ""
                    }`,
                    fontSize: `${
                      card?.otherFields?.pfCard1name2size
                        ? card?.otherFields?.pfCard1name2size + "px"
                        : ""
                    }`,
                  }}
                >
                  {card?.otherFields?.pfCard1name2}
                </h1>
              </div>
            </div>
          ) : (
            ""
          )}

          {/* --------------------------------------------------- Logo ---------------------------------------------------------------------------- */}

          {card?.companyLogo ? (
            card?.checkLogo ? (
              <div className="companyLogo ">
                <img src={card?.companyLogo} alt="" />
              </div>
            ) : (
              ""
            )
          ) : (
            ""
          )}

          {/* -------------------------------------------------------- social icon tab ----------------------------------------------------------------------- */}

          <div
            className="social-links"
            style={{
              backgroundColor: `${Highlightcolor ? Highlightcolor : ""}`,
            }}
          >
            <Link
              style={{
                backgroundColor: `${Iconcolor ? Iconcolor : ""}`,
              }}
              onClick={preview ? shareMail : ""}
            >
              {/* <img src={mailiconw} alt="" /> */}
              <FiMail size={23} color={BtIColor ? BtIColor : "white"} />
            </Link>
            <Link
              style={{
                backgroundColor: `${Iconcolor ? Iconcolor : ""}`,
              }}
              to={preview ? `tel:+${card?.phone ? card?.phone : card.phoneNumbers[0]?.number}` : ""}
            >
              {/* <img src={phoneiconw} alt="" /> */}
              <BiMobileAlt size={25} color={BtIColor ? BtIColor : "white"} />
            </Link>
            <Link
              style={{
                backgroundColor: `${Iconcolor ? Iconcolor : ""}`,
              }}
              to={
                preview
                  ? `sms:+${
                      card?.phone ? card?.phone : card.phoneNumbers[0]?.number
                    }`
                  : ""
              }
            >
              {/* <img src={messageiconw} alt="" /> */}
              <RiMessage2Line size={23} color={BtIColor ? BtIColor : "white"} />
            </Link>
            {whatsappNumber && (
              <Link
                style={{
                  backgroundColor: `${Iconcolor ? Iconcolor : ""}`,
                }}
                to={
                  preview
                    ? `https://wa.me/+${whatsappNumber}?text=${
                        whatsappMessage ? encodedMessage : "Hi%2C"
                      }`
                    : ""
                }
                target={preview ? "_blank" : ""}
              >
                {/* <img src={whatsappiconw} alt="" /> */}
                <BsWhatsapp size={23} color={BtIColor ? BtIColor : "white"} />
              </Link>
            )}
          </div>
          {/* --------------------------------------------------------------about----------------------------------------------------------------- */}

          {card?.about ? (
            <div
              className="contactOptions2"
              style={{
                color: `${Textcolor ? Textcolor : ""}`,
                backgroundColor: `${Highlightcolor ? Highlightcolor : ""}`,
              }}
            >
              {/* <h2>About {card?.aboutHeadline ? card?.aboutHeadline : 'Me'}</h2> */}
              <h2>
                {" "}
                {headlines?.aboutHeadline
                  ? headlines?.aboutHeadline
                  : t("about", "About Me")}
              </h2>
              <p className="whitespace-pre-line">{card?.about}</p>
            </div>
          ) : (
            ""
          )}

          {/* --------------------------------------------------contact details----------------------------------------------------------------------------- */}

          <div
            className="contactOptions2"
            style={{
              color: `${Textcolor ? Textcolor : ""}`,
              backgroundColor: `${Highlightcolor ? Highlightcolor : ""}`,
            }}
          >
            <h2>
              <span
                style={{
                  backgroundColor: `${Iconcolor ? Iconcolor : ""}`,
                }}
              >
                {/* <img src={phoneiconw} alt="" /> */}
                <BiMobileAlt size={25} color={BtIColor ? BtIColor : "white"} />
              </span>{" "}
              {/* {card?.contactHeadline ? card?.contactHeadline : 'Contact Me'} */}
              {headlines?.contactHeadline
                ? headlines?.contactHeadline
                : t("contact", "Contact Me")}
            </h2>
            <h3 className="mb-1">{t("call", "Call")}</h3>
            <div className="flex ">
              {card?.otherFields?.pimaryPhoneLabel && (
                <p className="mr-2">{card?.otherFields?.pimaryPhoneLabel}</p>
              )}
              {card?.phone && (
                <Link
                  style={{
                    color: `${Textcolor ? Textcolor : ""}`,
                  }}
                  to={preview ? `tel:+${card?.phone}` : ""}
                >
                  +{card?.phone}
                </Link>
              )}
            </div>
            {card?.secondaryPhone ? (
              <div className="flex ">
                {card?.otherFields?.secondaryPhoneLabel && (
                  <p className="mr-2">
                    {card?.otherFields?.secondaryPhoneLabel}
                  </p>
                )}
                <Link
                  style={{
                    color: `${Textcolor ? Textcolor : ""}`,
                  }}
                  to={preview ? `tel:+${card?.secondaryPhone}` : ""}
                >
                  +{card?.secondaryPhone}
                </Link>
              </div>
            ) : (
              ""
            )}
            {card?.otherFields?.phoneNumbers &&
              card?.otherFields?.phoneNumbers?.map((number, index) => (
                <Link
                  key={index} // Add a unique key for each element
                  style={{
                    color: Textcolor ? Textcolor : "", // Apply the color conditionally
                  }}
                  to={preview ? `tel:+${number}` : ""}
                >
                  +{number}
                </Link>
              ))}

            {card?.phoneNumbers &&
              card?.phoneNumbers?.map((number, index) => (
                <div
                  className={`flex ${
                    number?.alignCol
                      ? "flex-col gap-1"
                      : "flex-row gap-1 justify-between"
                  } w-full break-words overflow-hidden`}
                >
                  {number?.showLabel && (
                    <label className="break-words" htmlFor="">
                      {number?.label}
                    </label>
                  )}
                  <Link
                    key={index} // Add a unique key for each element
                    style={{
                      color: Textcolor ? Textcolor : "", // Apply the color conditionally
                    }}
                    to={preview ? `tel:+${number?.number}` : ""}
                  >
                    +{number?.number}
                  </Link>
                </div>
              ))}
            <h3 className="mb-1">{t("email", "Email")}</h3>
            {card?.email ? (
              <>
                {/* <h3>{t("email", "Email")}</h3> */}
                <Link
                  style={{
                    color: `${Textcolor ? Textcolor : ""}`,
                  }}
                  onClick={preview ? shareMail : ""}
                >
                  {card?.email}
                </Link>
              </>
            ) : (
              ""
            )}
            {card?.secondaryEmail ? (
              <Link
                style={{
                  color: `${Textcolor ? Textcolor : ""}`,
                }}
                onClick={preview ? shareMail2 : ""}
              >
                {card?.secondaryEmail}
              </Link>
            ) : (
              ""
            )}
            {card?.otherFields?.EmailIDs &&
              card?.otherFields?.EmailIDs?.map((email, index) => (
                <Link
                  key={index} // Add a unique key for each element
                  style={{
                    color: Textcolor ? Textcolor : "", // Apply the color conditionally
                  }}
                  onClick={preview ? (e) => shareMailAccording(e, email) : ""}
                >
                  {email}
                </Link>
              ))}

            {card?.emailList &&
              card?.emailList?.map((email, index) => (
                <>
                  <div
                    className={`flex ${
                      email?.alignCol
                        ? "flex-col gap-1"
                        : "flex-row gap-1 justify-between"
                    } w-full break-words overflow-hidden`}
                  >
                    {email?.showLabel && (
                      <label className="break-words">{email?.label}</label>
                    )}
                    <Link
                      key={index} // Add a unique key for each element
                      style={{
                        color: Textcolor ? Textcolor : "", // Apply the color conditionally
                      }}
                      onClick={
                        preview ? (e) => shareMailAccording(e, email.email) : ""
                      }
                      className="break-all overflow-hidden text-ellipsis"
                    >
                      {email.email}
                    </Link>
                  </div>
                </>
              ))}
            {/* <h3>{card?.addressHeadline ? card?.addressHeadline : 'Location'}</h3> */}
            <h3>
              {headlines?.addressHeadline
                ? headlines?.addressHeadline
                : t("address", "Location")}
            </h3>
            <Link
              style={{
                color: `${Textcolor ? Textcolor : ""}`,
              }}
            >
              {" "}
              {card?.address}
            </Link>
            {card?.locationUrl ? (
              <Link
                style={{
                  color: `${BtIColor ? BtIColor : ""}`,
                  backgroundColor: `${Iconcolor ? Iconcolor : ""}`,
                }}
                to={`${preview ? card?.locationUrl : ""}`}
                target={`${preview ? "_blank" : ""}`}
                className="blk-btn"
              >
                {/* <img src={arrowIcon} alt="" /> */}
                <BsCursor size={16} color={BtIColor ? BtIColor : "white"} />

                {t("direction", "Direction")}
              </Link>
            ) : (
              ""
            )}

            {/* -------------------------------- address1 --------------------------------  */}

            <Link
              style={{
                color: `${Textcolor ? Textcolor : ""}`,
              }}
            >
              {" "}
              {card?.otherFields?.address1 ? card.otherFields?.address1 : ""}
            </Link>
            {card?.otherFields?.locationUrl1 ? (
              <Link
                style={{
                  color: `${BtIColor ? BtIColor : ""}`,
                  backgroundColor: `${Iconcolor ? Iconcolor : ""}`,
                }}
                to={`${preview ? card?.otherFields?.locationUrl1 : ""}`}
                target={`${preview ? "_blank" : ""}`}
                className="blk-btn"
              >
                {/* <img src={arrowIcon} alt="" /> */}
                <BsCursor size={16} color={BtIColor ? BtIColor : "white"} />

                {t("direction", "Direction")}
              </Link>
            ) : (
              ""
            )}
          </div>

          {/* -----------------------------------------------------social media---------------------------------------------------------------- */}

          {SocialMediaImageCheck ||
          (card?.socialMedias && card?.socialMedias.length !== 0) ? (
            <div
              className="w-full rounded-[10px] "
              style={{
                backgroundColor: `${Highlightcolor ? Highlightcolor : ""}`,
              }}
            >
              <div
                className="px-6 pt-3 w-full"
                style={{
                  color: `${Textcolor ? Textcolor : ""}`,
                  // backgroundColor: `${Highlightcolor ? Highlightcolor : ""}`,
                }}
              >
                <h4 className="">
                  {headlines?.socialMediaHeadline
                    ? headlines?.socialMediaHeadline
                    : t("socialMedia", "Social Media")}
                </h4>
              </div>
              <div className="w-full ">
                {card?.socialMedias && card?.socialMedias.length !== 0 ? (
                  <ListSocialMediaClassic
                    className="w-full"
                    key={card._id}
                    preview={preview}
                    Hgcolor={Highlightcolor}
                    Textcolor={Textcolor}
                  />
                ) : (
                  <ListSocialMediaCls
                    className="w-full"
                    key={card._id}
                    preview={preview}
                    Hgcolor={Highlightcolor}
                    Textcolor={Textcolor}
                  />
                )}
              </div>
            </div>
          ) : (
            ""
          )}

          {/*  --------------------------------- website --------------------------------  */}

          {
            // card?.websiteName || card?.websiteUrl ||
            (card?.website ? card?.website[0]?.websiteName : "") ? (
              <div
                className="contactOptions2"
                style={{
                  color: `${Textcolor ? Textcolor : ""}`,
                  backgroundColor: `${Highlightcolor ? Highlightcolor : ""}`,
                }}
              >
                {/* <h4 >Website</h4> */}
                <h4>
                  {headlines?.websiteHeadline
                    ? headlines?.websiteHeadline
                    : t("website", "Website")}
                </h4>
                {/* {card?.websiteName &&
                card?.websiteUrl ?
                <div className="social-media2 ">
                  <Link
                    className="mb-3"
                    to={`${preview ? card?.websiteUrl : ""}`}
                    target={`${preview ? "_blank" : ""}`}
                  >
                    
                    <span className="websiteIcon" style={{ backgroundColor: `${Iconcolor ? Iconcolor : "black"}` }}>
                      <FiLink size={23} color={BtIColor ? BtIColor : 'white'} />

                    </span>
                    <h5
                      style={{
                        color: `${Textcolor ? Textcolor : ""}`,
                      }}
                    >
                      {" "}
                      {card?.websiteName}
                    </h5>
                  </Link>
                  <IoIosArrowForward className="mt-3" size={23} color={Textcolor ? Textcolor : 'black'} />
                </div>
                : ''
              } */}

                <WebsiteCls
                  website={card?.website}
                  preview={preview}
                  Textcolor={Textcolor}
                  Iconcolor={Iconcolor}
                  BtIColor={BtIColor}
                />
              </div>
            ) : (
              ""
            )
          }

          {/* --------------------------------- review ---------------------------------  */}

          {card?.reviews ? (
            card?.reviews[0]?.reviewName ? (
              <div
                className="contactOptions2"
                style={{
                  color: `${Textcolor ? Textcolor : ""}`,
                  backgroundColor: `${Highlightcolor ? Highlightcolor : ""}`,
                }}
              >
                {/* <h4>Review</h4> */}
                <h4>
                  {headlines?.reviewHeadline
                    ? headlines?.reviewHeadline
                    : t("review", "Review")}
                </h4>

                <ReviewCardCls
                  review={card?.reviews}
                  preview={preview}
                  Textcolor={Textcolor}
                />
              </div>
            ) : (
              ""
            )
          ) : (
            ""
          )}

          {/*  -------------------------------- downloads --------------------------------  */}

          {card?.files?.file1?.fileName ||
          card?.files?.file2?.fileName ||
          card?.files?.file3?.fileName ||
          card?.files?.file4?.fileName ? (
            <div
              className="contactOptions2"
              style={{ backgroundColor: `${Highlightcolor}` }}
            >
              <h4
                style={{
                  color: `${Textcolor ? Textcolor : ""}`,
                }}
              >
                {/* Downloads */}
                {headlines?.filesHeadline
                  ? headlines?.filesHeadline
                  : t("files", "Downloads")}
              </h4>

              {/* {(card?.files?.file1?.fileName) ?
                <div className="social-media2" >

                  <Link to={`${preview ? card?.files?.file1?.fileUrl : ""}`} target={`${preview ? "_blank" : ''}`} className="mb-5"  >
                    <svg width="40" height="40" stroke-width="1.5" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ color: `${Iconcolor ? Iconcolor : "black"}` }}> <path d="M9 17L15 17" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" /> <path d="M12 6V13M12 13L15.5 9.5M12 13L8.5 9.5" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" /> <path d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" /> </svg>
                    <h5 style={{
                      color: `${Textcolor ? Textcolor : ""}`,
                    }}> {card?.files?.file1?.fileName}</h5>
                  </Link>
                  <IoIosArrowForward size={23} color={Textcolor ? Textcolor : 'black'} />
                </div>
                : ""}

              {(card?.files?.file2?.fileName) ?
                <div className="social-media2" >

                  <Link to={`${preview ? card?.files?.file2?.fileUrl : ""}`} target={`${preview ? "_blank" : ''}`} className="mb-5"  >
                    <svg width="40" height="40" stroke-width="1.5" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ color: `${Iconcolor ? Iconcolor : "black"}` }}> <path d="M9 17L15 17" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" /> <path d="M12 6V13M12 13L15.5 9.5M12 13L8.5 9.5" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" /> <path d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" /> </svg>
                    <h5 style={{
                      color: `${Textcolor ? Textcolor : ""}`,
                    }}> {card?.files?.file2?.fileName}</h5>
                  </Link>
                  <IoIosArrowForward size={23} color={Textcolor ? Textcolor : 'black'} />
                </div>
                : ""}

              {(card?.files?.file3?.fileName) ?
                <div className="social-media2" >

                  <Link to={`${preview ? card?.files?.file3?.fileUrl : ""}`} target={`${preview ? "_blank" : ''}`} className="mb-5"   >
                    <svg width="40" height="40" stroke-width="1.5" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ color: `${Iconcolor ? Iconcolor : "black"}` }}> <path d="M9 17L15 17" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" /> <path d="M12 6V13M12 13L15.5 9.5M12 13L8.5 9.5" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" /> <path d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" /> </svg>
                    <h5 style={{
                      color: `${Textcolor ? Textcolor : ""}`,
                    }}> {card?.files?.file3?.fileName}</h5>
                  </Link>
                  <IoIosArrowForward size={23} color={Textcolor ? Textcolor : 'black'} />
                </div>
                : ""}

              {(card?.files?.file4?.fileName) ?
                <div className="social-media2" >

                  <Link to={`${preview ? card?.files?.file4?.fileUrl : ""}`} target={`${preview ? "_blank" : ''}`} className="mb-5"  >
                    <svg width="40" height="40" stroke-width="1.5" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ color: `${Iconcolor ? Iconcolor : "black"}` }}> <path d="M9 17L15 17" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" /> <path d="M12 6V13M12 13L15.5 9.5M12 13L8.5 9.5" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" /> <path d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" /> </svg>
                    <h5 style={{
                      color: `${Textcolor ? Textcolor : ""}`,
                    }}> {card?.files?.file4?.fileName}</h5>

                  </Link>
                  <IoIosArrowForward size={23} color={Textcolor ? Textcolor : 'black'} />
                </div>
                : ""} */}
              <DownloadsCardCls
                preview={preview}
                fileName={fileName}
                files={files}
                Iconcolor={Iconcolor}
                Textcolor={Textcolor}
              />
            </div>
          ) : (
            ""
          )}

          {/* --------------------------------------- highlight images ------------------------------ */}

          {card?.highlightPhotos[0].highlightPhotos1 ||
          card?.highlightPhotos[0].highlightPhotos2 ||
          card?.highlightPhotos[0].highlightPhotos3 ||
          card?.highlightPhotos[0].highlightPhotos4 ||
          card?.highlightPhotos[0].highlightPhotos5 ||
          card?.highlightPhotos[0].highlightPhotos6 ||
          card?.highlightPhotos[0].highlightPhotos7 ||
          card?.highlightPhotos[0].highlightPhotos8 ? (
            card?.checkHighlight ? (
              <div
                className="contactOptions2"
                style={{
                  color: `${Textcolor ? Textcolor : ""}`,
                  backgroundColor: `${Highlightcolor ? Highlightcolor : ""}`,
                }}
              >
                <h4
                  style={{
                    color: `${Textcolor ? Textcolor : ""}`,
                  }}
                >
                  {/* Downloads */}
                  {headlines?.filesHeadline
                    ? headlines?.filesHeadline
                    : t("Gallery", "Gallery")}
                </h4>
                <div className="photoGrid">
                  {card?.highlightPhotos[0].highlightPhotos1 ? (
                    <img
                      className="mb-4"
                      src={card?.highlightPhotos[0].highlightPhotos1}
                      alt=""
                    />
                  ) : (
                    ""
                  )}
                  {card?.highlightPhotos[0].highlightPhotos2 ? (
                    <img
                      className="mb-4"
                      src={card?.highlightPhotos[0].highlightPhotos2}
                      alt=""
                    />
                  ) : (
                    ""
                  )}
                  {card?.highlightPhotos[0].highlightPhotos3 ? (
                    <img
                      className="mb-4"
                      src={card?.highlightPhotos[0].highlightPhotos3}
                      alt=""
                    />
                  ) : (
                    ""
                  )}
                  {card?.highlightPhotos[0].highlightPhotos4 ? (
                    <img
                      className="mb-4"
                      src={card?.highlightPhotos[0].highlightPhotos4}
                      alt=""
                    />
                  ) : (
                    ""
                  )}
                  {card?.highlightPhotos[0].highlightPhotos5 ? (
                    <img
                      className="mb-4"
                      src={card?.highlightPhotos[0].highlightPhotos5}
                      alt=""
                    />
                  ) : (
                    ""
                  )}
                  {card?.highlightPhotos[0].highlightPhotos6 ? (
                    <img
                      className="mb-4"
                      src={card?.highlightPhotos[0].highlightPhotos6}
                      alt=""
                    />
                  ) : (
                    ""
                  )}
                  {card?.highlightPhotos[0].highlightPhotos7 ? (
                    <img
                      className="mb-4"
                      src={card?.highlightPhotos[0].highlightPhotos7}
                      alt=""
                    />
                  ) : (
                    ""
                  )}
                  {card?.highlightPhotos[0].highlightPhotos8 ? (
                    <img
                      className="mb-4"
                      src={card?.highlightPhotos[0].highlightPhotos8}
                      alt=""
                    />
                  ) : (
                    ""
                  )}
                </div>
              </div>
            ) : (
              ""
            )
          ) : (
            ""
          )}

          {/*  --------------------------------- footer ---------------------------------  */}
          {card?.footerText && <Footer color={Textcolor} />}
        </div>
      </section>

      {/* ---------------------------------- modal ---------------------------------  */}

      {qrModal ? (
        <QRModal
          handleClose={handleClose}
          Highlightcolor={Highlightcolor}
          Textcolor={Textcolor}
          Iconcolor={Iconcolor}
          BtIColor={BtIColor}
        />
      ) : null}

      {/* ----------------------------------  exchange contact ---------------------------------  */}
    </div>
  );
}

export default ClassicTheme2;
